export enum ProductUnitLabelField {
    ProductUnit = 1,
    LabelType = 2
}

(ProductUnitLabelField as any).__typeName = 'ProductUnitLabelField';